import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import DashboardLaneModel from "../../models/dashboard-lane";

export default class DashboardLanesRepository extends BaseRepository {
  static modelClass = DashboardLaneModel;
  modelName = "dashboard-lane";
}
